export default class Coordinate {
    constructor(item) {
      this.key = item.key;
      this.x = item.x;
      this.y = item.y;
    }
  }
  